import Divider from "@/components/Divider";
import { useAuthActions } from "@/context/auth/AuthContext";
import loadStore from "@/utils/generateStore";
import { useNavigate } from "react-router";

interface ExpiredVersionProps {
  onOpenModal: () => void;
}

function ExpiredVersion({ onOpenModal }: ExpiredVersionProps) {
  const { logout } = useAuthActions();
  const navigate = useNavigate();

  return (
    <div className="fixed inset-0 z-999 bg-black/75 flex justify-center items-center">
      <div className="flex flex-col items-center justify-center gap-5 max-w-[600px] p-2.5">
        <div className="flex flex-col items-center justify-center gap-[5px]">
          <p className="text-2xl text-white underline decoration-brand-primary decoration-[3px]">
            La versión de prueba ha expirado
          </p>
          <p className="text-center">
            Esperamos que hayas disfrutado de tu experiencia con nuestra versión
            de prueba de Trud. Para continuar utilizando todas las
            funcionalidades sin interrupciones, por favor contáctanos para
            adquirir la versión completa.
          </p>
        </div>

        <Divider />

        <div className="flex flex-col items-center justify-center gap-[5px]">
          <button
            type="button"
            onClick={onOpenModal}
            className="text-text-secondary cursor-pointer transition-all duration-200 hover:text-text-primary"
          >
            Más información
          </button>
        </div>

        <button
          type="button"
          onClick={async () => {
            const store = await loadStore();
            await store.delete("token");
            logout();
            navigate("/login");
          }}
          className="cursor-pointer hover:underline"
        >
          Logout
        </button>
      </div>
    </div>
  );
}

export default ExpiredVersion;
